import { Suspense, lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { LoginPage } from '@/features/auth';
import { LoadingBlock } from '@/shared/components/States';
import { AppShell } from '../layout/AppShell';
import { RequireAuth } from './RequireAuth';

const lazyPage = (loader: () => Promise<{ default: React.ComponentType }>) => {
  const C = lazy(loader);
  return <Suspense fallback={<LoadingBlock rows={6} />}><C /></Suspense>;
};

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/apply/:jobId', element: lazyPage(() => import('@/features/apply')) },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/', element: lazyPage(() => import('@/features/overview')) },
          { path: '/jobs', element: lazyPage(() => import('@/features/jobs').then((m) => ({ default: m.JobsPage }))) },
          { path: '/jobs/:jobId', element: lazyPage(() => import('@/features/jobs').then((m) => ({ default: m.JobDetailPage }))) },
          { path: '/jobs/:jobId/upload', element: lazyPage(() => import('@/features/upload')) },
          { path: '/applicants', element: lazyPage(() => import('@/features/applicants')) },
          { path: '/wellfound', element: lazyPage(() => import('@/features/openings')) },
          { path: '/candidates/:appId', element: lazyPage(() => import('@/features/candidates')) },
          { path: '/live', element: lazyPage(() => import('@/features/live')) },
          { path: '/review', element: lazyPage(() => import('@/features/review')) },
          { element: <RequireAuth roles={['admin']} />, children: [{ path: '/analytics', element: lazyPage(() => import('@/features/analytics')) }] },
          { path: '/settings', element: lazyPage(() => import('@/features/settings')) },
          // Connections moved under Settings; old links and bookmarks still land there.
          { path: '/connections', element: <Navigate to="/settings?tab=connections" replace /> },
          { path: '*', element: <Navigate to="/" replace /> },
        ],
      },
    ],
  },
]);
